module.exports = {
          srcSet: __webpack_public_path__ + "public/115f0ca0d7f4fb91e3c4fd1cc2abb428-80.png"+" 80w",
          images:[ {path: __webpack_public_path__ + "public/115f0ca0d7f4fb91e3c4fd1cc2abb428-80.png",width: 80,height: 80}],
          src: __webpack_public_path__ + "public/115f0ca0d7f4fb91e3c4fd1cc2abb428-80.png",
          toString:function(){return __webpack_public_path__ + "public/115f0ca0d7f4fb91e3c4fd1cc2abb428-80.png"},
          
          width: 80,
          height: 80
        }